// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* P2P Dispute Management */
.dispute-management-page .dashboard-body {
  padding-bottom: 2rem;
}

.dispute-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.35);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.dispute-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.dispute-stat-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.dispute-stat-card__icon {
  font-size: 1.25rem;
  margin-bottom: 0.25rem;
}

.dispute-stat-card__icon--default {
  color: #64748b;
}

.dispute-stat-card__icon--pending {
  color: #ea580c;
}

.dispute-stat-card__icon--resolved {
  color: #16a34a;
}

.dispute-stat-card__value {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text, #1e293b);
}

.dispute-stat-card__label {
  font-size: 0.85rem;
  color: var(--text-muted, #64748b);
}

.dispute-filters-section {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.dispute-filters__title {
  margin: 0 0 1.25rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text, #1e293b);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dispute-filters__title i {
  color: #0f766e;
}

.dispute-filters-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem 1.25rem;
}

.dispute-filter-group label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-muted, #64748b);
}

.dispute-filter-group input,
.dispute-filter-group select {
  width: 100%;
  padding: 0.6rem 0.85rem;
  font-size: 0.875rem;
  font-family: inherit;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 8px;
  background: #fff;
  color: var(--text, #1e293b);
}

.dispute-filter-group input:focus,
.dispute-filter-group select:focus {
  outline: none;
  border-color: #0f766e;
}

.dispute-filters-actions {
  margin-top: 1.25rem;
}

.dispute-btn-reset {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text, #475569);
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.dispute-btn-reset:hover {
  background: #e2e8f0;
}

.dispute-list-section {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.dispute-list__title {
  margin: 0 0 1.25rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text, #1e293b);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dispute-list__title i {
  color: #0f766e;
}

.dispute-table-wrap {
  overflow-x: auto;
}

.dispute-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.dispute-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.dispute-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text, #1e293b);
}

.dispute-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.dispute-table tbody tr:hover {
  background: #f8fafc !important;
}

.dispute-side-badge {
  display: inline-block;
  padding: 0.3rem 0.65rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
}

.dispute-side-badge--buy {
  background: #dcfce7;
  color: #166534;
}

.dispute-side-badge--sell {
  background: #fef2f2;
  color: #b91c1c;
}

.dispute-by-badge {
  display: inline-block;
  padding: 0.3rem 0.65rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
}

.dispute-by-badge--buyer {
  background: #dbeafe;
  color: #1e40af;
}

.dispute-by-badge--seller {
  background: #fef3c7;
  color: #b45309;
}

.dispute-admin-status {
  display: inline-block;
  padding: 0.3rem 0.65rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
}

.dispute-admin-status--pending {
  background: #fef3c7;
  color: #b45309;
}

.dispute-admin-status--resolved {
  background: #dcfce7;
  color: #166534;
}

.dispute-table__reason {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dispute-btn-view {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: #0f766e;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.dispute-btn-view:hover {
  opacity: 0.9;
}

@media (max-width: 1024px) {
  .dispute-stats {
    grid-template-columns: 1fr;
  }
  .dispute-filters-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .dispute-filters-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/P2P/DisputeManagementPage.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* P2P Dispute Management */\n.dispute-management-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.dispute-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.35);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n}\n\n.dispute-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.dispute-stat-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.dispute-stat-card__icon {\n  font-size: 1.25rem;\n  margin-bottom: 0.25rem;\n}\n\n.dispute-stat-card__icon--default {\n  color: #64748b;\n}\n\n.dispute-stat-card__icon--pending {\n  color: #ea580c;\n}\n\n.dispute-stat-card__icon--resolved {\n  color: #16a34a;\n}\n\n.dispute-stat-card__value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n}\n\n.dispute-stat-card__label {\n  font-size: 0.85rem;\n  color: var(--text-muted, #64748b);\n}\n\n.dispute-filters-section {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.dispute-filters__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.dispute-filters__title i {\n  color: #0f766e;\n}\n\n.dispute-filters-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem 1.25rem;\n}\n\n.dispute-filter-group label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-muted, #64748b);\n}\n\n.dispute-filter-group input,\n.dispute-filter-group select {\n  width: 100%;\n  padding: 0.6rem 0.85rem;\n  font-size: 0.875rem;\n  font-family: inherit;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text, #1e293b);\n}\n\n.dispute-filter-group input:focus,\n.dispute-filter-group select:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.dispute-filters-actions {\n  margin-top: 1.25rem;\n}\n\n.dispute-btn-reset {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text, #475569);\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.dispute-btn-reset:hover {\n  background: #e2e8f0;\n}\n\n.dispute-list-section {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.dispute-list__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.dispute-list__title i {\n  color: #0f766e;\n}\n\n.dispute-table-wrap {\n  overflow-x: auto;\n}\n\n.dispute-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.dispute-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.dispute-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text, #1e293b);\n}\n\n.dispute-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.dispute-table tbody tr:hover {\n  background: #f8fafc !important;\n}\n\n.dispute-side-badge {\n  display: inline-block;\n  padding: 0.3rem 0.65rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.dispute-side-badge--buy {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.dispute-side-badge--sell {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.dispute-by-badge {\n  display: inline-block;\n  padding: 0.3rem 0.65rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.dispute-by-badge--buyer {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.dispute-by-badge--seller {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.dispute-admin-status {\n  display: inline-block;\n  padding: 0.3rem 0.65rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.dispute-admin-status--pending {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.dispute-admin-status--resolved {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.dispute-table__reason {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dispute-btn-view {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: #0f766e;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.dispute-btn-view:hover {\n  opacity: 0.9;\n}\n\n@media (max-width: 1024px) {\n  .dispute-stats {\n    grid-template-columns: 1fr;\n  }\n  .dispute-filters-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .dispute-filters-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
